@if (loading && !runs.length) {
	<app-pre-loading msg="Carregando o histórico de paginação"></app-pre-loading>
} @else if (!runs.length) {
	<app-empty-data message="Nenhuma paginação registrada para este processo ainda."></app-empty-data>
} @else {
	<ul class="list-group list-group-flush eph">
		@for (run of runs; track run.id) {
			<li class="list-group-item px-0 bg-transparent">
				<div class="eph-entry">
					<fa-icon [icon]="run.icon" class="eph-icon" [ngClass]="'text-' + run.tone" [spin]="run.active"></fa-icon>
					<div class="flex-grow-1 min-w-0">
						<div class="d-flex flex-wrap align-items-center gap-2">
							<span class="fw-600">{{ run.typeLabel }}</span>
							<span class="badge rounded-xl fw-700" [ngClass]="'text-bg-' + run.tone">{{ run.statusLabel }}</span>
							@if (run.applicable) {
								<button
									*permissions="'planning.electronic-process.manage'"
									type="button"
									class="btn btn-sm btn-outline-primary ms-auto"
									(click)="review.emit(run)">
									Revisar e aplicar
								</button>
							}
						</div>
						@if (summary(run); as text) {
							<p class="eph-meta mb-0">{{ text }}</p>
						}
						@if (run.failed && run.error?.message) {
							<p class="eph-error mb-0">{{ run.error.message }}</p>
						}
						@if (run.applicable && run.expiresAt) {
							<p class="eph-meta mb-0">Pode ser aplicada até {{ run.expiresAt | date: "dd/MM/yyyy 'às' HH:mm" }}</p>
						}
						<p class="eph-meta mb-0">
							{{ run.createdAt | date: "dd/MM/yyyy 'às' HH:mm" }}
							@if (run.finishedAt && run.type !== Type.OUTDATED && run.type !== Type.APPLY) {
								· concluída {{ run.finishedAt | date: "dd/MM/yyyy 'às' HH:mm" }}
							}
							@if (run.createdBy && authors[run.createdBy]) {
								· por {{ authors[run.createdBy] }}
							}
						</p>

						@if (expandable(run)) {
							<button type="button" class="btn btn-link btn-sm px-0" (click)="toggle(run)" [attr.aria-expanded]="expanded.has(run.id)">
								<fa-icon [icon]="expanded.has(run.id) ? 'chevron-down' : 'chevron-right'" class="me-1"></fa-icon>
								{{ expanded.has(run.id) ? 'Ocultar detalhes' : 'Ver detalhes' }}
							</button>
						}

						@if (expanded.has(run.id)) {
							<div class="eph-detail">
								@if (run.failures.length || run.error) {
									<app-electronic-process-pagination-failures [failure]="run.error"></app-electronic-process-pagination-failures>
								}
								@if (run.changes?.length) {
									<app-electronic-process-pagination-changes [changes]="run.changes"></app-electronic-process-pagination-changes>
								}
								@if (run.details; as details) {
									<p class="mb-0 small">
										<span class="fw-600">{{ details.label }}</span>
										@if (details.before?.ordering !== details.after?.ordering) {
											<span class="d-block">Posição: {{ details.before?.ordering }} → {{ details.after?.ordering }}</span>
										}
										@if (details.changed?.includes('MAIN_FILE')) {
											<span class="d-block">Arquivo principal trocado</span>
										}
										@if (details.changed?.includes('ATTACHMENTS')) {
											<span class="d-block">
												Anexos: {{ details.before?.attachmentIds?.length ?? 0 }} → {{ details.after?.attachmentIds?.length ?? 0 }}
												(inclusão, remoção ou troca de ordem)
											</span>
										}
									</p>
								}
							</div>
						}
					</div>
				</div>
			</li>
		}
	</ul>

	@if (hasMore) {
		<div class="text-center">
			<button type="button" class="btn btn-link btn-sm" (click)="loadMore()" [disabled]="loading">
				<app-label-loading-dots [loading]="loading" label="Carregar mais"></app-label-loading-dots>
			</button>
		</div>
	}
}
